import ButtonList from '@/components/Record/OutlookButton/OutlookModal/OutlookContents/ButtonList';
import { useState } from 'react';
import ScheduleList from '@/components/Record/OutlookButton/OutlookModal/OutlookContents/ScheduleList';
import { Container, StyledDate, StyledNoData, StyledSubTitle } from './styles';
import { useTranslation } from 'react-i18next';
import { useFetchThisWeekCalendarList } from '@/hooks/apiHooks';
import usePlatform from '@/components/Record/hooks/usePlatform';
import MsAuthRequired from '@/components/Home/@components/MsAuthRequired';
import useMsReauth from '@/hooks/useMsReauth';
import { isMsAuthExpired } from '@/utils/api/msAzure/authError';

type P = {
  handleClose?: () => void;
};

const OutlookContents = ({ handleClose }: P) => {
  const { isMobilePath } = usePlatform();
  const { t } = useTranslation();
  const [offSet, setOffSet] = useState(0);

  const { data, error } = useFetchThisWeekCalendarList(offSet, 'UTC');
  const { reauth, isPending: isReauthPending } = useMsReauth();

  const handleNextWeek = () => {
    setOffSet((prev) => prev + 1);
  };

  const handlePrevWeek = () => {
    setOffSet((prev) => prev - 1);
  };

  const handleThisWeek = () => {
    setOffSet(0);
  };

  // MS 인증 만료는 조용히 사라지면 안 된다. 모달을 연 사용자가 원인을 알 수 없기 때문.
  if (isMsAuthExpired(error)) {
    return (
      <MsAuthRequired
        disabled={isReauthPending}
        onClick={reauth}
        sx={{ padding: isMobilePath ? '24px 20px' : '24px' }}
      />
    );
  }

  if (!data?.data) {
    return null;
  }

  const eventData = data.data;

  return (
    <div style={{ padding: isMobilePath ? '24px 0 20px 0' : '' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: isMobilePath ? 'column' : 'row',
          alignItems: isMobilePath ? 'start' : 'center',
          justifyContent: 'space-between',
          padding: isMobilePath ? '0 20px' : '',
          borderBottom: isMobilePath ? '1px solid #E7E9EC' : '',
        }}
      >
        <div>
          <div style={{ display: 'flex' }}>
            <StyledDate>{data?.data?.displayRange.formatted}</StyledDate>
          </div>
          <StyledSubTitle>
            {t(
              '회의를 선택하면, 회의 일시, 참석자, 첨부파일 정보를 불러올 수 있어요.',
            )}
          </StyledSubTitle>
        </div>
        <ButtonList
          weekOffset={offSet}
          handleNextWeek={handleNextWeek}
          handlePrevWeek={handlePrevWeek}
          handleThisWeek={handleThisWeek}
        />
      </div>
      <Container
        style={{
          marginTop: isMobilePath ? '16px' : '',
          paddingTop: isMobilePath ? '0' : '',
          backgroundColor: isMobilePath ? 'white' : '',
          height: isMobilePath ? '' : '832px',
          overflowY: isMobilePath ? undefined : 'auto',
        }}
      >
        {eventData.events.length > 0 ? (
          <ScheduleList data={eventData} handleClose={handleClose} />
        ) : (
          <StyledNoData>{t('예정된 일정이 없습니다.')}</StyledNoData>
        )}
      </Container>
    </div>
  );
};
export default OutlookContents;
